var _rect, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_808_26215",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_808_26215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H11.2598C11.4724 3.5 11.6506 3.57183 11.7943 3.7155C11.9378 3.859 12.0095 4.03717 12.0095 4.25C12.0095 4.46283 11.9378 4.641 11.7943 4.7845C11.6506 4.92817 11.4724 5 11.2598 5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19H11.2598C11.4724 19 11.6506 19.0718 11.7943 19.2155C11.9378 19.359 12.0095 19.5372 12.0095 19.75C12.0095 19.9628 11.9378 20.141 11.7943 20.2845C11.6506 20.4282 11.4724 20.5 11.2598 20.5H5.30775ZM17.6173 12.75H9.84625C9.63342 12.75 9.45517 12.6782 9.3115 12.5345C9.168 12.391 9.09625 12.2128 9.09625 12C9.09625 11.7872 9.168 11.609 9.3115 11.4655C9.45517 11.3218 9.63342 11.25 9.84625 11.25H17.6173L15.6943 9.327C15.5558 9.1885 15.4849 9.01958 15.4818 8.82025C15.4786 8.62092 15.5494 8.44367 15.6943 8.2885C15.8391 8.13333 16.0148 8.05317 16.2213 8.048C16.4276 8.043 16.6083 8.118 16.7635 8.273L19.8578 11.3672C20.0384 11.5481 20.1288 11.759 20.1288 12C20.1288 12.241 20.0384 12.4519 19.8578 12.6328L16.7635 15.727C16.6148 15.8757 16.4383 15.949 16.2338 15.947C16.0293 15.9452 15.8494 15.8667 15.6943 15.7115C15.5494 15.5563 15.4796 15.3782 15.4848 15.177C15.4898 14.9757 15.5648 14.8026 15.7098 14.6578L17.6173 12.75Z",
    fill: "#1C1B1F"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.1e0e105620461ceb11050d5861e81b19.svg";
export { ForwardRef as ReactComponent };